import {SubStatusDto} from "../generated/account-client";
import { PlanLength, PlanType } from "./types";

export const loadJS = (href: string, callback: () => void) => {
  let doc = document, lnk = doc.createElement('script'), ref;
  const refs = (doc.body || doc.getElementsByTagName("head")[0]).childNodes;
  ref = refs[refs.length - 1];
  lnk.type = 'text/javascript';
  lnk.src = href;

  lnk.addEventListener("load", function () {
    if (callback !== undefined && typeof callback === 'function') callback();
  });

  ref?.parentNode?.insertBefore(lnk, ref.nextSibling);
  return lnk;
};

export const getJSPath = (name: string) => {
  const host = window.location.host;
  let path = `https://www.musthavemenus.com/home/${name}`;
  if (host === 'test.mhmfun.com') {
    path = `https://test.mhmfun.com/home-test/${name}`;
  } else if (host === 'staging.mhmfun.com' || window.location.href.includes('/xstage')) {
    path = `https://staging.mhmfun.com/home-stage/${name}`;
  } else if (host === 'www.musthavemenus.com') {
    path = `https://www.musthavemenus.com/home/${name}`;
  } else if (host === 'localhost:3000') {
    path = `http://localhost:3000/${name}`;
  }
  return `${path}?cb=${new Date().getTime()}`;
}

declare global {
  interface SetupProps {
    memberId: string;
    onSuccess?: () => void;
    onDismiss?: () => void;
    closable?: boolean;
    flow?: string;
    subDto?: SubStatusDto,
    container?: HTMLElement,
    planType?: PlanType,
    planLength?: PlanLength,
    onBack?: () => void;
    downgrade?: boolean;
  }

  interface ILProps {
    memberId: number,
    locationId: number,
  }

  interface MemberImageDto {
    id?: string;
    name?: string;
    path?: string;
    visitorId?: string;
    memberId?: number;
    locationId?: number;
    source?: string;
    createdDate?: Date;
    altText?: string;
  }

  interface ILMenuItemImageDto {
    url?: string;
    memberImageId?: string;
    sequence?: number;
    removed?: boolean;
    hidden?: boolean;
    sync?: boolean;
    createdDate?: Date;
    updatedDate?: Date;
    externalId?: string;
    id?: string;
  }

  export interface ComponentProps extends SetupProps {
    container: HTMLElement;
  }

  interface Window {
    MHM: {
      ProModal: {
        upgrade: (props: SetupProps) => void;
        upgradeToDesign: (props: SetupProps) => void;
        upgradeInline: (props: SetupProps) => void;
        switchToAnnual: (props: SetupProps) => void;
        switchToMonthly: (props: SetupProps) => void;
        switchToPro: (props: SetupProps) => void;
        switchToProWithOverview: (props: SetupProps) => void;
        switchToDesign: (props: SetupProps) => void;
        upgradeToPro: (props: SetupProps) => void;
        upgradeWithLocations: (props: SetupProps) => void;
        upgradeWithUsers: (props: SetupProps) => void;
        cancel: (props: SetupProps) => void;
        reactivate: (props: SetupProps) => void;
        reactivateFromCancelled: (props: SetupProps) => void;
        reactivateFromDeclined: (props: SetupProps) => void;
        payPastDue: (props: SetupProps) => void;
        reactivateFromPaused: (props: SetupProps) => void;
        pause: (props: SetupProps) => void;
        resume: (props: SetupProps) => void;
        addLocation: (props: SetupProps) => void;
        destroy: () => void;
        changeBilling: (props: SetupProps) => Promise<void>;
        reactivateDSALicense: (props: SetupProps) => Promise<void>;
        addDSA: (props: SetupProps) => void;
      },
      Components: {
        trialForm: (props: ComponentProps) => void;
      }
    },
    ItemLibrary: {
      Lib: {
        getPublishedMenus: (props: ILProps) => Promise<any>;
        getPOSImages: (props: ILProps) => Promise<ILMenuItemImageDto[]>;
        getMemberImages: (props: ILProps) => Promise<MemberImageDto[]>;
        getImagePath: (img: MemberImageDto) => string;
        show: (props: ILProps) => void;
        hide: () => void;
      }
    },
    rewardful: (action: string, data: any) => void;
    Rewardful: {
      referral: string;
    }
    dataLayer: any[];
    pagesense: any;
  }
}

window.MHM = window.MHM || {};
